import ProductHistoryHtml from './templates/product-history.html'

export function ProductHistoryDirective () {
  return {
    controller: 'ProductHistoryCtrl',
    restrict: 'E',
    templateUrl: ProductHistoryHtml,
    scope: {
      product: '=',
      vendorInvoices: '='
    }
  }
};
